module.exports = __webpack_public_path__ + "img/product.d42871f0.png";